import LegalLayout, { LegalBlock } from "./LegalLayout";
import { CONTACT } from "@/components/site/Reveal";

export default function Terms() {
  return (
    <LegalLayout title="Terms & Conditions" updated="June 2026">
      <LegalBlock heading="1. Agreement">
        <p>
          These Terms & Conditions govern your use of the {CONTACT.company} website and the
          engagement of our services. By accessing this site or engaging us, you agree to be
          bound by these terms.
        </p>
      </LegalBlock>
      <LegalBlock heading="2. Services">
        <p>
          {CONTACT.company} provides digital marketing, online advertising, social media
          management, branding, content strategy and business consulting services. The
          specific scope of any engagement will be defined in a separate written proposal or
          statement of work.
        </p>
      </LegalBlock>
      <LegalBlock heading="3. Intellectual Property">
        <p>
          All content on this website, including text, graphics, logos and design, is the
          property of {CONTACT.company} unless otherwise stated and may not be reproduced
          without prior written consent.
        </p>
      </LegalBlock>
      <LegalBlock heading="4. Payment & Fees">
        <p>
          Fees, payment schedules and deliverables are agreed in writing prior to the start
          of any project. Invoices are payable within the terms stated on each invoice.
        </p>
      </LegalBlock>
      <LegalBlock heading="5. Limitation of Liability">
        <p>
          While we strive to deliver excellent results, {CONTACT.company} shall not be liable
          for any indirect or consequential losses arising from the use of our services, to
          the maximum extent permitted by law.
        </p>
      </LegalBlock>
      <LegalBlock heading="6. Governing Law">
        <p>
          These terms are governed by the laws of England and Wales. Any disputes shall be
          subject to the exclusive jurisdiction of the English courts.
        </p>
      </LegalBlock>
      <LegalBlock heading="7. Contact">
        <p>
          Questions about these terms can be directed to {CONTACT.email} or {CONTACT.phone}.
          Registered address: {CONTACT.address}.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
